<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item in comList" :label="item.title + `(${pageTotal[item.name] || 0})`" :name="item.name" lazy
        :key="item.name">
      </el-tab-pane>
      <InterForm @querySubmit="queryHandler" @overEmit="getDataSource" :inboundType="inboundType" :tableType="tableType"
        :forwarder="forwarder" ref="InterForm" />

      <InterBtnBox :selectedRows="selectedRows" :forwarder="forwarder" :InterForm="$refs.InterForm"
        @overEmit="getDataSource" :tableType="tableType" @refresh="refresh" v-if="inboundType === 1" />

      <InterList :tableType="tableType" :inboundType="inboundType" @refresh="refresh" @overEmit="getDataSource"
        :dataSource="dataSource" :clean='clean' @pageChange="pageChangeCall" @selectChange="selectChangeCall"
        ref="interlist" :forwarder="forwarder" :total="query.total"></InterList>
    </el-tabs>
  </div>
</template>

<script>
import InterForm from './components/InterForm'
import InterList from "./components/InterList";
import InterBtnBox from "./components/InterBtnBox";
import { inboundOrderPage, getTotalNum } from "@/apis/inHouse";
export default {
  title: 'com',
  name: "com",
  components: {
    InterForm,
    InterBtnBox, InterList
  },
  props: {
    inboundType: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      activeName: '0',
      forwarder: [],
      query: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      clean: false,
      selectedRows: [],
      dataSource: [],
      tableType: '0',
      pageTotal: {}
    }
  },
  created() {
    this.getNumber()
  },
  computed: {
    comList: function () {
      return this.inboundType == 1 ? [{ name: '0', title: '全部' }, { name: '3', title: '待确认' }, { name: '4', title: '已完成' }, { name: '5', title: '已关闭' }] : [{ name: '0', title: '全部' }, { name: '1', title: '待签收' }, { name: '2', title: '入库中' }, { name: '4', title: '已完成' }]
    }
  },
  methods: {
    handleClick(e) {
      this.tableType = e.name
      this.queryHandler()
    },
    queryHandler: function (payload) {
      this.query = {
        ...this.query,
        ...payload,
      };
      this.query.current = 1
      this.getDataSource()
      this.getNumber()
      if (this.$refs.interlist) {
        this.$refs.interlist.resetPage()
      }
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    selectChangeCall: function (rows) {
      this.selectedRows = rows;
    },
    refresh() {
      this.getDataSource()
      this.getNumber()
      if (this.$refs.interlist) {
        this.$refs.interlist.resetPage()
      }
      this.getNumber()
    },
    getDataSource: function () {
      // 获取列表数据
      const params = {
        ...this.query,
        pageNum: this.query.current,
        inboundType: this.inboundType,
        status: this.tableType != '0' ? this.tableType : undefined,
      };
      this.clean = true;
      inboundOrderPage(params)
        .then((res) => {
          if (res.success) {
            res.data.records.length > 0 && res.data.records.forEach(item=>item.sonArray=[])
            this.dataSource = res.data.records
            this.query.total = res.data.total
          }
          // const {}
        })
        .finally((_) => {
        });
    },
    getNumber() {
      getTotalNum({
        inboundType: this.inboundType
      }).then((res) => {
        this.pageTotal = {
          0: res.data.all, //全部
          1: res.data.signNums,//待签收
          2: res.data.inboundingNums,//入库中
          3: res.data.toBeConfirmedNums,//待确认
          4: res.data.completedNums,//已完成
          5: res.data.closedNums,//已关闭
        }
      })
    }
  },
}
</script>

<style scoped></style>